import { render, staticRenderFns } from "./CoSyncConflictList.vue?vue&type=template&id=8f94e51a&scoped=true&"
import script from "./CoSyncConflictList.vue?vue&type=script&lang=ts&"
export * from "./CoSyncConflictList.vue?vue&type=script&lang=ts&"
import style0 from "./CoSyncConflictList.vue?vue&type=style&index=0&id=8f94e51a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f94e51a",
  null
  
)

export default component.exports